<template>

  <div class="box" :style="Cover">
    <div class="titlebox">
      <div class="line"></div>
      <div class="Subtitle">
        <h1 class="Stitle">{{Info.title}}</h1>
        <p class="text">{{Info.body}}</p>
      </div>
    </div>
    <div v-for="(item,index) in Submenu">
      <div :class="{'card animated fadeInLeft ':DividNum==4,'card2 animated fadeInLeft ':DividNum==2}"
           v-on:click="goIn(index)"

      >

        <div class="textarea">
          <div>
            <p class="Tnumber">{{ item.id }}</p>
            <p class="subtitle" v-html="item.subtitle"></p>
            <h1 class="title" v-html=" item.text"></h1>
          </div>
          <div>
            <img src="../assets/b01.png"/>
          </div>
        </div>
      </div>
    </div>




  </div>


</template>

<script>

export default {
  name: 'HelloWorld',
  props: {
    Info: Object,
    Submenu: Array,
    DividNum:Number,
    BGImgUrl:String
  },
  data () {
    return {
      StartIn:false,
      Hitaffect:{id:'',status:false},
      Cover: {backgroundImage: 'url(' + require('../assets/' + this.BGImgUrl) + ')'},
      CardIN:{}
    }
  },
  watch: {

  },
  mounted () {

  },
  computed:{

  },
  methods: {
    goIn(t){
      this.Hitaffect.id=t;
      this.Hitaffect.status=true;
      this.$emit('cellback',t)

    }
    ,
  }
}
</script>

<style scoped lang="scss">
  .subtitle{
    font-size: 1.5rem;
  }
  .titlebox {

    color: #ffffff;
    margin-left: 60px;
    height: 180px;
    text-align: left;
    /*width: 300px*/
  }

  .line {
    float: left;
    background-color: #df5e04;
    width: 3px;
    height: 100px;
  }

  .Subtitle {
    padding-left: 30px;
    float: left;
  }

  .box {
    padding: 180px 0px 50px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    height: 100%;


  }

  .card {
    border-right: 1px solid rgba(0,0,0,0.2);
    border-bottom: 1px solid rgba(0,0,0,0.2);
    padding: 30px;
    color: black;
    width: 25%;
    height: 300px;
    background-color: #ffffffcc;
    float: left;
  }
  .card2 {
    border-right: 1px solid rgba(0,0,0,0.2);
    border-bottom: 1px solid rgba(0,0,0,0.2);
    padding: 30px;
    color: black;
    width: 50%;
    height: 300px;
    background-color: #ffffffcc;
    float: left;
  }

  .textarea {

    color: black;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /*font-size: 1.5rem;*/
    margin-left: auto;
    margin-right: auto;
    text-align: left;
    width: 95%;
    /*padding-top: 750px;*/
  }

  .text{
    width: 900px;
    margin-top: 10px;
    font-size: 1.4rem;
  }
  .title{
    font-size: 2rem;
    font-weight: 400;
  }
  .Stitle{
    font-size: 3rem;
    font-weight: 400;
    line-height: 3rem;
  }
</style>
